/**
 * 用量服务：分页用量记录、用量概览、按日聚合。
 *
 * @module services/usage
 */
import type {
  Paginated,
  UsageDailyPoint,
  UsageOverview,
  UsageRecord,
} from '@/types';
import { API } from '@/config/api';
import { request } from './http';

/** 用量查询入参。 */
export interface UsageQuery {
  page?: number;
  pageSize?: number;
  model?: string;
  from?: string;
  to?: string;
}

/** 分页查询用量记录。 */
export async function getUsage(
  query: UsageQuery = {},
): Promise<Paginated<UsageRecord>> {
  return request<Paginated<UsageRecord>>({
    method: 'GET',
    url: API.usage.list,
    params: query,
  });
}

/** 获取用量概览。 */
export async function getOverview(): Promise<UsageOverview> {
  return request<UsageOverview>({ method: 'GET', url: API.usage.overview });
}

/** 获取按日聚合用量（默认近 7 天）。 */
export async function getDaily(days = 7): Promise<UsageDailyPoint[]> {
  return request<UsageDailyPoint[]>({
    method: 'GET',
    url: API.usage.daily,
    params: { days },
  });
}
